import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../helpers/axiosInstance";
import { toast } from "react-toastify";

const initialState = {
    inboxData: [],
    pagination: null,
    loading: false,
    error: null,
};

export const  getUserManagementInboxData = createAsyncThunk(
    "usermanagement/inbox",
    async ({ user, pagination, entityType  }, thunkAPI) => {
        try {
            const { url, endpoint } = user?.routesConfig;

            const isMaker = window?.location?.pathname?.includes('maker');
            const isChecker = window?.location?.pathname?.includes('checker');
            
            let apiURL;
            
            if (isMaker) {
                const base = url?.backoffice;
                const endpointpath = endpoint?.backoffice?.processMaker;
                const institution = user?.institution?.value;
                apiURL = base + endpointpath + `${pagination.pageSize}/${pagination.currentPage}/` + institution + `/${entityType}`;
            } else if (isChecker) {
                const base = url?.backoffice;
                const endpointpath = endpoint?.backoffice?.processChecker;
                const institution = user?.institution?.value;
                apiURL = base + endpointpath + `${pagination.pageSize}/${pagination.currentPage}/` + institution + `/${entityType}`;
            } else {
                return thunkAPI.rejectWithValue({ skip: true });
            }

            const response = await axiosInstance.get(apiURL);
            return response?.data;
        } catch (error) {
            toast.error(error.response.data.message);
            throw error.response;
        }
    }
);

export const postAddedUserReview = createAsyncThunk(
    "usermanagement/inbox/added-user-review",
    async ({ user, body }, thunkAPI) => {
        try {
            const { url, endpoint } = user?.routesConfig;

            const isMaker = window?.location?.pathname?.includes('maker');
            const isChecker = window?.location?.pathname?.includes('checker');

            let apiURL;
            let updatedBody;

            if (isMaker) {
                const base = url?.backoffice;
                const endpointpath = endpoint?.backoffice?.addUserReviewMaker;
                updatedBody = body;

                apiURL = base + endpointpath;
            } else if (isChecker) {
                const base = url?.backoffice;
                const endpointpath = endpoint?.backoffice?.addUserReviewChecker;
                updatedBody = {

                    processid: body?.processId,
                    reason: body?.reason,
                    isaccepted: body?.isaccepted
                };

                apiURL = base + endpointpath;
            } else {
                return thunkAPI.rejectWithValue({ skip: true });
            }

            const response = await axiosInstance.post(apiURL, updatedBody);
            toast.success(body.isaccepted ? 'Request accepted and send successfully' : 'Request rejected and send successfully');
            return { ...response?.data, status: response.status };
        } catch (error) {
            toast.error(error.response.data.message);
            throw error.response;
        }
    }
);

export const postUpdatedUserReview = createAsyncThunk(
    "usermanagement/inbox/updated-user-review",
    async ({ user, body }, thunkAPI) => {
        try {
            const { url, endpoint } = user?.routesConfig;

            const isMaker = window?.location?.pathname?.includes('maker');
            const isChecker = window?.location?.pathname?.includes('checker');

            let apiURL;
            let updatedBody;

            if (isMaker) {
                const base = url?.backoffice;
                const endpointpath = endpoint?.backoffice?.editUserReviewMaker;
                updatedBody = body;
                apiURL = base + endpointpath;
            } else if (isChecker) {
                const base = url?.backoffice;
                const endpointpath = endpoint?.backoffice?.editUserReviewChecker;
                updatedBody = {
                    processid: body?.processId,
                    reason: body?.reason,
                    isaccepted: body?.isaccepted
                };
                apiURL = base + endpointpath;
            } else {
                return thunkAPI.rejectWithValue({ skip: true });
            }

            const response = await axiosInstance.post(apiURL, updatedBody);
            toast.success(body.isaccepted ? 'Request accepted and send successfully' : 'Request rejected and send successfully');
            return { ...response?.data, status: response.status };
        } catch (error) {
            toast.error(error.response.data.message);
            throw error.response;
        }
    }
);

// export const postAddedRoleReview = createAsyncThunk(
//     "usermanagement/inbox/added-role-review",
//     async ({ user, body }, thunkAPI) => {
//         try {
//             const { url, endpoint } = user?.routesConfig;

//            const isMaker = window?.location?.pathname?.includes('maker');
//            const isChecker = window?.location?.pathname?.includes('checker');

//             let apiURL;
//             let updatedBody;

//             if (isMaker) {
//                 const base = url?.backoffice;
//                 const endpointpath = endpoint?.backoffice?.addRoleReviewMaker;
//                 updatedBody = body;
//                 apiURL = base + endpointpath;
//             } else if (isChecker) {
//                 const base = url?.backoffice;
//                 const endpointpath = endpoint?.backoffice?.addRoleReviewChecker;
//                 updatedBody = {

//                     processid: body?.processId,
//                     reason: body?.reason,
//                     isaccepted: body?.isaccepted
//                 };
//                 apiURL = base + endpointpath;
//             } else {
//                 return thunkAPI.rejectWithValue({ skip: true });
//             }

//             const response = await axiosInstance.post(apiURL, updatedBody);
//             toast.success(body.isaccepted ? 'Request accepted and send successfully' : 'Request rejected and send successfully');
//             return { ...response?.data, status: response.status };
//         } catch (error) {
//             toast.error(error.response.data.message);
//             throw error.response;
//         }
//     }
// );

// export const postUpdatedRoleReview = createAsyncThunk(
//     "usermanagement/inbox/updated-role-review",
//     async ({ user, body }, thunkAPI) => {
//         try {
//             const { url, endpoint } = user?.routesConfig;

//            const isMaker = window?.location?.pathname?.includes('maker');
//            const isChecker = window?.location?.pathname?.includes('checker');

//             let apiURL;
//             let updatedBody;

//             if (isMaker) {
//                 const base = url?.backoffice;
//                 const endpointpath = endpoint?.backoffice?.editRoleReviewMaker;
//                 updatedBody = body;
//                 apiURL = base + endpointpath;
//             } else if (isChecker) {
//                 const base = url?.backoffice;
//                 const endpointpath = endpoint?.backoffice?.editRoleReviewChecker;
//                 updatedBody = {

//                     processid: body?.processId,
//                     reason: body?.reason,
//                     isaccepted: body?.isaccepted
//                 };
//                 apiURL = base + endpointpath;
//             } else {
//                 return thunkAPI.rejectWithValue({ skip: true });
//             }

//             const response = await axiosInstance.post(apiURL, updatedBody);
//             toast.success(body.isaccepted ? 'Request accepted and send successfully' : 'Request rejected and send successfully');
//             return { ...response?.data, status: response.status };
//         } catch (error) {
//             toast.error(error.response.data.message);
//             throw error.response;
//         }
//     }
// );

const userManagementInboxSlice = createSlice({
    name: "usermanagementInbox",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getUserManagementInboxData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getUserManagementInboxData.fulfilled, (state, action) => {
                const { resp, currentPage, pageSize, totalItem, totalPages } = action?.payload;
                state.loading = false;
                state.inboxData = resp || [];
                state.pagination = { currentPage, pageSize, totalItem, totalPages }
            })
            .addCase(getUserManagementInboxData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            // ADD USER REVIEW
            .addCase(postAddedUserReview.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(postAddedUserReview.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(postAddedUserReview.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            // UPDATE USER REVIEW
            .addCase(postUpdatedUserReview.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(postUpdatedUserReview.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(postUpdatedUserReview.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            // ADD ROLE REVIEW
            // .addCase(postAddedRoleReview.pending, (state) => {
            //     state.loading = true;
            //     state.error = null;
            // })
            // .addCase(postAddedRoleReview.fulfilled, (state) => {
            //     state.loading = false;
            // })
            // .addCase(postAddedRoleReview.rejected, (state, action) => {
            //     state.loading = false;
            //     state.error = action.error.message;
            // })

            // UPDATE ROLE REVIEW
            // .addCase(postUpdatedRoleReview.pending, (state) => {
            //     state.loading = true;
            //     state.error = null;
            // })
            // .addCase(postUpdatedRoleReview.fulfilled, (state) => {
            //     state.loading = false;
            // })
            // .addCase(postUpdatedRoleReview.rejected, (state, action) => {
            //     state.loading = false;
            //     state.error = action.error.message;
            // })
    },
});

export default userManagementInboxSlice.reducer;